import { useContext } from 'react';
import {
  CurrServicesAndMeasuresContext,
  CurrServicesAndMeasuresState,
} from '../context/CurrServicesAndMeasuresContext';

// Custom hook to use the CustomerSummary context
const useCurrServicesAndMeasures = (): CurrServicesAndMeasuresState => {
  const context = useContext(CurrServicesAndMeasuresContext);
  if (context === undefined) {
    throw new Error(
      'useCurrServicesAndMeasures must be used within a CustomerSummaryProvider'
    );
  }
  return context;
};

export default useCurrServicesAndMeasures;
